import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Box,
  Chip,
} from "@mui/material";

export const getManagementMedal = (managementNo) => {
  switch (managementNo) {
    case 1:
      return {
        medal: "🏆",
        color: "#FFD700",
        label: "Gold Winner",
        textColor: "#333333",
      }; // Dark text on Gold
    case 2:
      return {
        medal: "🥈",
        color: "#C0C0C0",
        label: "Silver Winner",
        textColor: "#ffffff",
      };
    case 3:
      return {
        medal: "🥉",
        color: "#CD7F32",
        label: "Bronze Winner",
        textColor: "#ffffff",
      };
    default:
      return null;
  }
};

export const getDepartmentMedal = (departmentNo) => {
  if (departmentNo === 1) {
    return {
      trophy: "🥇",
      color: "#1270c6",
      label: "Department Winner",
      textColor: "#ffffff",
    };
  } else if (departmentNo === 2) {
    return {
      trophy: "🥈",
      color: "#1270c6",
      label: "Department Winner",
      textColor: "#ffffff",
    };
  }
  return null;
};

const VoteCard = ({ item, onViewDetails }) => {
  const isDepartmentPublished = item.passedOnDepartmentLevel !== null;
  const isManagementPublished =
    !!isDepartmentPublished && item.passedOnManagementLevel !== null;

  const managementMedal =
    item.typeId === "M" && !!item.passedOnManagementLevel
      ? getManagementMedal(item.managementNo)
      : null;
  const departmentMedal =
    item.typeId === "D" && !!item.passedOnDepartmentLevel
      ? getDepartmentMedal(item.departmentNo)
      : null;

  const borderColor =
    managementMedal?.color || departmentMedal?.color || "#e0e0e0";

  return (
    <Card
      className="vote-card h-100"
      sx={{
        border: `2px solid ${borderColor}`,
        boxShadow:
          managementMedal || departmentMedal
            ? `0 0 10px ${borderColor}`
            : "0 2px 4px rgba(0,0,0,0.1)",
        borderRadius: 3,
        textAlign: "center",
        p: 2,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Box>
          <Box mb={2}>
            <Avatar
              sx={{
                bgcolor: "#1976d2",
                width: 60,
                height: 60,
                margin: "0 auto",
                fontSize: "1.5rem",
              }}
            >
              {item.names.charAt(0)}
            </Avatar>
          </Box>

          {managementMedal && (
            <Box mb={1}>
              <Typography variant="h4">{managementMedal.medal}</Typography>
              <Chip
                label={managementMedal.label}
                style={{
                  backgroundColor: managementMedal.color,
                  color: managementMedal.textColor || "white",
                  fontWeight: "bold",
                }}
              />
            </Box>
          )}

          {departmentMedal && (
            <Box mb={1}>
              <Typography variant="h4">{departmentMedal.trophy}</Typography>
              <Chip
                label={departmentMedal.label}
                style={{
                  backgroundColor: departmentMedal.color,
                  color: departmentMedal.textColor || "white",
                  fontWeight: "bold",
                }}
              />
            </Box>
          )}

          <Typography variant="h6" fontWeight="bold">
            {item.names}
          </Typography>
          <Typography variant="body2" color="textSecondary" mb={2}>
            {item.positionName}
          </Typography>
          <table>
            <tbody>
              <tr>
                <td align="right" style={{ width: "50%" }}>
                  <Typography variant="body2">
                    <strong>Fiscal Year:</strong>
                  </Typography>
                </td>
                <td align="center">{item.fiscalYearName}</td>
              </tr>
              {managementMedal ? (
                <tr>
                  <td align="right">
                    <Typography variant="body2">
                      <strong>Management No:</strong>
                    </Typography>
                  </td>
                  <td align="center">
                    <Typography variant="body2">
                      {isManagementPublished ? item.managementNo : "-"}
                    </Typography>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td align="right">
                    <Typography variant="body2">
                      <strong>Department No:</strong>{" "}
                    </Typography>
                  </td>
                  <td align="center">
                    <Typography variant="body2">
                      {isDepartmentPublished ? item.departmentNo : "-"}
                    </Typography>
                  </td>
                </tr>
              )}

              <tr>
                <td align="right">
                  <Typography variant="body2">
                    <strong>Votes:</strong>
                  </Typography>
                </td>
                <td align="center">
                  {!!isManagementPublished || isDepartmentPublished
                    ? item.voterCount
                    : "-"}
                </td>
              </tr>

              <tr>
                <td align="right">
                  <Typography variant="body2">
                    <strong>Behavior:</strong>{" "}
                  </Typography>
                </td>
                <td align="center">
                  <Typography variant="body2">
                    {!!isManagementPublished || isDepartmentPublished
                      ? item.behaviorRate
                      : "-"}
                  </Typography>
                </td>
              </tr>
            </tbody>
          </table>

          {(!!departmentMedal || !!managementMedal) && (
            <Typography
              variant="body2"
              fontStyle="italic"
              color="textSecondary"
              mt={1}
            >
              Excellent performance throughout the year.
            </Typography>
          )}
        </Box>

        <Box mt="auto">
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3, borderRadius: 2 }}
            onClick={() => onViewDetails(item)}
          >
            View Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default VoteCard;
